// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3VMpZ","row":"styles_row__E1ELw"};